

export const API_URL = {
    LOGIN: '/admin/sign-in',
    REWARD_LIST: '/fanstore/rewards',
    ADD_REWARD: '/fanstore/createReward',
    REWARD_DETAILS: '/fanstore/rewards/',
    USER_UNLOCK_REWARD: '/user-drops/rewardId',
    DEACTIVATE_REWARD: '/fanstore/deactivateReward/',
    DELETE_REWARD: '/fanstore/rewards/',
    EDIT_REWARD: '/fanstore/rewards/'
};